import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-table-icon',
  templateUrl: 'table-icon.component.html'
})
export class TableIconComponent {
  constructor() {}
}
